import { type FC, type ReactNode } from "react";

import { cx } from "@emotion/css";
import { Modal } from "@snapchat/snap-design-system";

import { type ModalProps } from "../hooks";

import { Form, formModalStyleMinHeight, formModalStyles } from "./FormModal.styles";

interface FormModalProps {
    footer: ReactNode;
    modalProps: ModalProps & { width?: number; centered?: boolean };
    minHeight?: number;
    children?: ReactNode;
    className?: string;
    dataTestId?: string;
    width?: number;
    formClassName?: string;
}

export const FormModal: FC<FormModalProps> = ({
    modalProps,
    minHeight,
    footer,
    children,
    className,
    dataTestId,
    width,
    formClassName,
}) => (
    <Modal
        {...modalProps}
        padBody={false}
        footer={footer}
        data-testid={dataTestId}
        width={width}
        className={cx(formModalStyles, !!minHeight && formModalStyleMinHeight(minHeight), className)}
    >
        <Form className={formClassName}>{children}</Form>
    </Modal>
);
